var SupportLiveVoucherStatusAndNotesPresentation;

SupportLiveVoucherStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: I18n.translate('js.modules.notes.editable_live_notes_message')
  },
  not_editable: {
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    expired: {
      status: "Event has passed",
      notes: ""
    },
    expired_unredeemed: {
      status: "Event has passed",
      notes: ""
    },
    expired_redeemed: {
      status: "Event has passed",
      notes: ""
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    available: {
      status: "Ready to print",
      notes: I18n.translate('js.modules.notes.not_editable_notes_message')
    }
  }
};

module.exports = SupportLiveVoucherStatusAndNotesPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9saXZlX3ZvdWNoZXJfbWVzc2FnZXMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9saXZlX3ZvdWNoZXJfbWVzc2FnZXMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsNENBQUEsR0FDQztFQUFBLFFBQUEsRUFDQztJQUFBLE1BQUEsRUFBUSwwRUFBUjtJQUNBLEtBQUEsRUFBTyxJQUFJLENBQUMsU0FBTCxDQUFlLDhDQUFmLENBRFA7R0FERDtFQUdBLFlBQUEsRUFDQztJQUFBLFFBQUEsRUFDQztNQUFBLE1BQUEsRUFBUSwwREFBUjtNQUNBLEtBQUEsRUFBTyxFQURQO0tBREQ7SUFHQSxPQUFBLEVBQ0M7TUFBQSxNQUFBLEVBQVEsa0JBQVI7TUFDQSxLQUFBLEVBQU8sRUFEUDtLQUpEO0lBTUEsa0JBQUEsRUFDQztNQUFBLE1BQUEsRUFBUSxrQkFBUjtNQUNBLEtBQUEsRUFBTyxFQURQO0tBUEQ7SUFTQSxnQkFBQSxFQUNDO01BQUEsTUFBQSxFQUFRLGtCQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FWRDtJQVlBLFFBQUEsRUFDQztNQUFBLE1BQUEsRUFBUSwwREFBUjtNQUNBLEtBQUEsRUFBTyxFQURQO0tBYkQ7SUFlQSxTQUFBLEVBQ0M7TUFBQSxNQUFBLEVBQVEsZ0JBQVI7TUFDQSxLQUFBLEVBQU8sSUFBSSxDQUFDLFNBQUwsQ0FBZSw2Q0FBZixDQURQO0tBaEJEO0dBSkQ7OztBQXVCRCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
